import BulletItem from './BulletItem';

const ResponsibilityList = ({ list }) => {
  return (
    <div>
      <ul className="flex flex-col gap-3">
        {list?.map((item, index) => (
          <BulletItem key={index} color="neutral">
            <p className="text-neutral-900">{item}</p>
          </BulletItem>
        ))}
      </ul>
    </div>
  );
};

export default ResponsibilityList;
